var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoneycomb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.9 42",
    enableBackground: "new 0 0 35.9 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M2 7.4L0 3.9 2 .4h4l2.1 3.5L6 7.4zM2 17.4l-2-3.5 2-3.5h4l2.1 3.5L6 17.4zM2 27.3l-2-3.5 2-3.5h4l2.1 3.5L6 27.3zM2 36.3l-2-3.5 2-3.5h4l2.1 3.5L6 36.3zM9.9 0l25 14 1 28-26-5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoneycomb);
export default __webpack_public_path__ + "static/media/honeycomb.e0cdd39a12404ffb9d8fcc15c0941115.svg";
export { ForwardRef as ReactComponent };